import {
  CHARGE_STATUS_CODES,
  type ChargeStatusCode,
} from "@/pages/sy/models/Charge";

export const CHARGE_STATUS_LABELS: Record<ChargeStatusCode, string> = {
  [CHARGE_STATUS_CODES.SCHEDULED]: "Scheduled",
  [CHARGE_STATUS_CODES.OPEN]: "Open",
  [CHARGE_STATUS_CODES.CLOSED]: "Closed",
  [CHARGE_STATUS_CODES.CHARGED_INTO_EAF]: "Charged into EAF",
};

export const CHARGE_STATUS_OPTIONS = [
  {
    value: CHARGE_STATUS_CODES.SCHEDULED,
    label: CHARGE_STATUS_LABELS[CHARGE_STATUS_CODES.SCHEDULED],
  },
  {
    value: CHARGE_STATUS_CODES.OPEN,
    label: CHARGE_STATUS_LABELS[CHARGE_STATUS_CODES.OPEN],
  },
  {
    value: CHARGE_STATUS_CODES.CLOSED,
    label: CHARGE_STATUS_LABELS[CHARGE_STATUS_CODES.CLOSED],
  },
  {
    value: CHARGE_STATUS_CODES.CHARGED_INTO_EAF,
    label: CHARGE_STATUS_LABELS[CHARGE_STATUS_CODES.CHARGED_INTO_EAF],
  },
] as const;

export const getChargeStatusLabel = (code: string): string =>
  CHARGE_STATUS_LABELS[code as ChargeStatusCode] ?? code;
